var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoTaggedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.65625 12.6953C0.257812 12.6953 0 12.3984 0 12.0469C0 11.8125 0.117188 11.5703 0.335938 11.4375L0.953125 11.0391C2.03125 10.3125 3.95312 8.50781 3.95312 6.59375V3.66406H2.84375C2.28125 3.66406 2.14062 3.28125 2.44531 2.84375L4.19531 0.359375C4.45312 0 4.82812 0.0078125 5.07812 0.359375L6.82031 2.85156C7.125 3.28125 6.97656 3.66406 6.42969 3.66406H5.32031V6.59375C5.32031 8.50781 7.23438 10.3203 8.32031 11.0391L8.9375 11.4375C9.14844 11.5703 9.27344 11.8047 9.27344 12.0391C9.27344 12.4219 9.00781 12.6953 8.60938 12.6953C8.41406 12.6953 8.20312 12.625 8.01562 12.5L7.60938 12.2266C6.51562 11.4922 4.91406 9.82812 4.64844 9.00781H4.625C4.35156 9.83594 2.75 11.4922 1.66406 12.2266L1.25781 12.5C1.07031 12.625 0.859375 12.6953 0.65625 12.6953Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoTaggedIcon);
export default __webpack_public_path__ + "static/media/autoTaggedIcon.7a66f65b976c59f3ce968aea395424d3.svg";
export { ForwardRef as ReactComponent };